import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaskSinNumberPipe } from '../../pipes/mask-sin-number.pipe';

@Component({
  selector: 'app-sin-display-field',
  templateUrl: './sin-display-field.component.html',
  styleUrls: ['./sin-display-field.component.scss'],
  standalone: true,
  imports: [AsyncPipe, MaskSinNumberPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SinDisplayFieldComponent {
  @Input() sin!: string;

  private _showFullSin = new BehaviorSubject(false);
  public showFullSin$ = this._showFullSin as Observable<boolean>;

  public iconSrc$ = this.showFullSin$.pipe(
    map(showFullSin => (showFullSin ? '/assets/icons/dark/Eye On.svg' : '/assets/icons/dark/Eye Off.svg'))
  );

  public toggleShowFullSin(event: MouseEvent): void {
    event.stopPropagation();
    this.showFullSin$.once(masked => this._showFullSin.next(!masked));
  }
}
